class DeliveryWizardController {
    constructor(addressService, timeslotService, shopperService, loginService, fulfilmentSteps) {
        this.addressService = addressService;
        this.timeslotService = timeslotService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.fulfilmentSteps = fulfilmentSteps;
        this.shopperService = shopperService;

        this.timeTable = undefined;
    }

    $onInit() {
        if (this.currentAddress) {
            this.fetchTimeslots(this.currentAddress.AreaId);
        }
    }

    $onChanges(changes) {
        if (changes.isActive && changes.isActive.currentValue === false) {
            if (this.currentStep === this.fulfilmentSteps.address) {
                this.decideAddressLater();
            } else if (this.currentStep === this.fulfilmentSteps.timeslot) {
                this.decideTimeLater();
            }
        }
    }

    fetchTimeslots(areaId) {
        this.timeTable = [];
        this.timeslotService.listTimeslots(areaId, 'Courier', this.shouldGetDynamicTimetable).then((dates) => {
            this.reservedWindow = this.timeslotService.findReservedWindow(dates);
            this.timeTable = dates.length === 0 ? null : dates;
            return dates;
        });
    }

    loginToSaveAddress(loginCallback) {
        if (this.shopperService.IsGuest) {
            this.loginService.promptForLogin(
                this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, loginCallback);
        } else {
            loginCallback();
        }
    }

    saveNewManualAddressForDelivery(address) {
        this.loginToSaveAddress(() =>
            this.addressService.saveManualAddress(address)
                .then(addressResponse => this.addressSelected(addressResponse.Address)));
    }

    saveNewAutoAddressForDelivery(address) {
        this.loginToSaveAddress(() =>
            this.addressService.saveAutoAddress(address)
                .then(addressResponse => this.addressSelected(addressResponse.Address)));
    }

    setDeliveryAddress(address) {
        this.addressSelected(address);
    }

    addressSelected(address) {
        this.currentAddress = address;
        this.fetchTimeslots(this.currentAddress.AreaId);

        this.changes();
        this.currentStep = this.fulfilmentSteps.timeslot;
    }

    decideAddressLater() {
        this.currentAddress = null;
        this.selectedDate = null;
        this.selectedTime = null;
        this.finish();
    }

    setDate(date) {
        this.selectedDate = date;
    }

    setTime(time) {
        this.selectedTime = time;
        this.finish();
    }

    decideTimeLater() {
        this.selectedDate = null;
        this.selectedTime = null;
        this.finish();
    }

    changes() {
        this.onFulfilmentChange(this.getCurrentFulfilmentInfo());
    }

    finish() {
        this.onFulfilmentSelected(this.getCurrentFulfilmentInfo());
    }

    getCurrentFulfilmentInfo() {
        return {
            fulfilmentInfo: {
                address: this.currentAddress,
                fulfilmentMethod: 'Courier', // matches the enum in the api
                fulfilmentWindow: {
                    date: this.selectedDate,
                    time: this.selectedTime,
                },
            },
        };
    }
}

DeliveryWizardController.$inject = ['AddressService', 'FulfilmentTimeslotService', 'ShopperService', 'LoginService', 'FulfilmentSteps'];

const deliveryWizardComponentDefinition = {
    controller: DeliveryWizardController,
    bindings: {
        onFulfilmentSelected: '&',
        onFulfilmentChange: '&',
        currentAddress: '<?',
        currentTimeslot: '<?',
        allowDecideLater: '<?',
        currentStep: '=',
        isActive: '<',
        shouldGetDynamicTimetable: '<?',
    },
    template: require('./delivery-wizard.component.html').trim(),
};

module.exports = {
    DeliveryWizardController,
    deliveryWizardComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/delivery/delivery-wizard.component.js